Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var container = {
    width: '100%',
    alignItems: 'center',
    position: 'absolute',
    height: '100%'
  };
  var shape1 = {
    position: 'absolute',
    zIndex: 0,
    top: -40,
    left: 0,
    width: 56
  };
  var shape2 = {
    position: 'absolute',
    zIndex: 0,
    left: 0,
    bottom: 0,
    width: 97
  };
  var shape3 = {
    position: 'absolute',
    zIndex: 0,
    right: 0,
    bottom: 40,
    width: 91
  };
  if (bp.is([bp.mobile_s, bp.mobile_xs])) {
    container.display = 'none';
  }
  if (bp.is([bp.mobile_m, bp.mobile_l, bp.mobile_xl])) {
    shape1.width = 70;
    shape2.width = 121;
    shape3.width = 114;
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    shape1.width = 120;
    shape2.width = 207;
    shape3.width = 193;
  }
  shape1.height = 94 / 42 * shape1.width;
  shape2.height = 123 / 72 * shape2.width;
  shape3.height = 136 / 67 * shape3.width;
  container.minHeight = shape1.height + shape2.height + 50;
  var styles = _reactNative.StyleSheet.create({
    container: container,
    shape1: shape1,
    shape2: shape2,
    shape3: shape3
  });
  return {
    styles: styles
  };
};